import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import messages from '../messages';
import helpers from '../helpers';

// import FontDisplay from './font_display'
/* eslint-disable react/prop-types */
import {
  BrowserRouter as Router, Route, Switch, HashRouter,
} from 'react-router-dom';


const Home = React.lazy(() => import('./home'));
const FontDisplay = React.lazy(() => import('./font_display'));


const useStyles = makeStyles(() => ({
  root: {
    margin: -12,
    fontFamily: 'Mulat Abay',
  }
}));

const initialState = { lang: true, text: "/ተፈጥሮ እውን የሆነችው, ትንንሽ ነገሮች ተሰባስበው ትልልቅ ነገሮችን እየፈጠሩ ነው.", size: 24 }
const reducer = (state, action) => {
  switch (action.type) {
    case 'lang': 
      return { ...state, lang: !state.lang };
    case 'size':
      return { ...state, size: action.size};
    case 'text':
      return  {...state, text: action.text};
    default: throw new Error('Unexpected action');
  }
};


export default (props): JSX.Element => {

  const classes = useStyles();
  const [state, dispatch] = React.useReducer(reducer, initialState);
  React.useEffect(() => {
    const max = messages.words.length;
    let newText = messages.words[helpers.getRandomInt(max)]
    for (let index = 0; index < 5; index += 1) {
      newText += ` ${messages.words[helpers.getRandomInt(max)]}`
    }
    dispatch({ type: 'text', text: newText });
  }, [])
  return (
    <React.Suspense fallback={<div>Loading..</div>}>
    <Router>
      <Switch>
        <Route path="/" exact render={(args): JSX.Element => <Home {...args} state={state} dispatch={dispatch} />} />
        <Route path="/fonts/:fontID" render={(args): JSX.Element => <FontDisplay {...args} state={state} dispatch={dispatch} />} />
        <Route render={(args): JSX.Element => <Home {...args} state={state} dispatch={dispatch} />} />
      </Switch>
    </Router>
   </React.Suspense> 
    // <div className={classes.root}>
    //   <Header state={state} dispatch={dispatch} />
    //   <Cover />
    //   <FontDisplay />
    //   <MulatAbay />
    //   <MulatAwash />
    //   <MulatAhmed />
    //   <MulatAddis />
    //   <SellPoints />
    //   <About/>
    //   <Inspire />
    //   <Footer />
    // </div>
  );
};

